import { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'

import Layout from '../components/Layout'
import FilterMenu from '../components/FilterMenu'
import SearchPanel from '../components/SearchPanel'
import GenresPanel from '../components/GenresPanel'
import Grid from '../components/Grid'
import Footer from '../components/Footer'
import { withTranslation, i18n, Router } from '../i18n'

import { Container } from '../styles/listsStyles'
import { stagesFilters } from '../constants/filters'
import { generateQueryString } from '../api/utils'

@inject('store')
@observer
class Places extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    currentLanguage: PropTypes.string.isRequired,
    genres: PropTypes.arrayOf(String).isRequired,
    datetime: PropTypes.string.isRequired,
    ordering: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    store: PropTypes.instanceOf(Object).isRequired
  }

  state = {
    genres: this.props.genres,
    datetime: this.props.datetime,
    ordering: this.props.ordering,
    search: this.props.search
  }

  static getInitialProps({ req, query }) {
    const currentLanguage = req ? req.language : i18n.language
    return {
      namespacesRequired: ['common', 'genres', 'contacts', 'auth', 'reset-password'],
      currentLanguage,
      datetime: query.datetime || '',
      ordering: query.ordering || 'name',
      search: query.search || '',
      genres: query.genres ? query.genres.split(',') : []
    }
  }

  applyFilters = (filters) => {
    Router.replace(`/places?${generateQueryString({ ...Router.query, ...filters })}`)
    this.setState({ ...filters })
  }

  handleMainFilterChange = (filter) => {
    const { datetime } = this.state
    if (!filter.startsWith('datetime')) {
      if (datetime !== '' && filter === 'name') {
        this.applyFilters({ ordering: filter, datetime: '' })
      } else this.applyFilters({ ordering: filter })
    } else {
      const isoTime = filter.split('=')[1]
      if (datetime && datetime === isoTime) {
        this.applyFilters({ datetime: '' })
        return
      }
      this.applyFilters({ datetime: isoTime })
    }
  }

  handleGenreChange = (genre) => {
    const { genres } = this.state
    if (genres.includes(genre)) {
      genres.splice(genres.indexOf(genre), 1)
    } else {
      genres.push(genre)
    }

    if (genres.length === 0) {
      this.clearGenres()
      return
    }
    this.applyFilters({ genres: [...genres] })
  }

  handleSearchChange = (text) => {
    this.applyFilters({ search: text })
  }

  clearGenres = () => {
    this.applyFilters({ genres: [] })
  }

  render() {
    const {
      t,
      currentLanguage,
      store: {
        user: { token }
      }
    } = this.props
    const {
      ordering, search, genres, datetime
    } = this.state

    const filters = {
      genres: [...genres],
      search,
      ordering,
      datetime
    }

    return (
      <Layout meta={{ title: t('PAGE_PLACES_TITLE') }} coverImageUrl="places-cover" currentLanguage={currentLanguage}>
        <Container>
          <div className="content">
            <div className="searchPanel spPlaces">
              <SearchPanel
                placeholder={t('find_stage')}
                buttonText={t('search')}
                value={search}
                onChange={this.handleSearchChange}
              />
            </div>
            <div className="row">
              <div className="menu spMenu">
                <FilterMenu
                  items={stagesFilters}
                  value={ordering || stagesFilters[0].value}
                  onChange={this.handleMainFilterChange}
                  hasTimes={ordering === stagesFilters[1].value}
                  datetime={datetime}
                />
              </div>
              <div className="searchPanelMobile">
                <SearchPanel
                  placeholder={t('find_stage')}
                  buttonText={t('search')}
                  value={search}
                  onChange={this.handleSearchChange}
                />
              </div>
              <div className="list">
                <div className="filters">
                  <GenresPanel values={genres} onChange={this.handleGenreChange} clear={this.clearGenres} />
                </div>
                <div className="gridContainer">
                  <Grid filters={filters} entity="places" token={token} />
                </div>
              </div>
            </div>
          </div>
        </Container>
        <Footer />
      </Layout>
    )
  }
}

export default withTranslation(['common'])(Places)
